module.exports = __webpack_public_path__ + "static/img/2.6706362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/2.png
// module id = tWLv
// module chunks = 0